import { redirectTo } from '../../utils/CommonUtil';
import { getCookie, setCookie } from '../../utils/CookieUtil';
import { ADMIN_LOGIN_ADDRESS } from '../../utils/PageAddressUtil';
import RequestUtil from '../../utils/APIRequestUtil';

import { Flex, Box, Text, Button, TabNav } from '@radix-ui/themes';
import { ScrollArea } from '@radix-ui/react-scroll-area';
import { useEffect, useState } from 'react';

const sendLogout = async () => {
    await RequestUtil.post('/api/admin/logout', null, {
        'username': getCookie('username'),
        'sessionId': getCookie('sessionId')
    });

    setCookie('username', 'xxx');
    setCookie('sessionId', 'xxx');
};

const logout = () => {
    sendLogout();

    redirectTo(ADMIN_LOGIN_ADDRESS);
}

export default function AdminMenu() {
    const [pathname, setPathname] = useState('');

    useEffect(() => {
        setPathname(window.location.pathname);
    });

    return (
        <div className="redesign-admin-menu">
            <Flex gap="1" direction="column">
                <Box mt="2">
                    <Text>{getCookie('username')}</Text> |
                    <Button size="1" className="redesign-btn-secondary" onClick={() => logout()}>退出登录</Button>
                </Box>
                <ScrollArea>
                    <div className="redesign-pills redesign-pills--admin">
                        <a href="/admin/blog-requests" className={`redesign-pill${pathname === '/admin/blog-requests' ? ' active' : ''}`}>博客审核</a>
                        <a href="/admin/blog-requests/add" className={`redesign-pill${pathname === '/admin/blog-requests/add' ? ' active' : ''}`}>提交博客</a>
                        <a href="/admin/recommended-posts" className={`redesign-pill${pathname === '/admin/recommended-posts' ? ' active' : ''}`}>推荐文章管理</a>
                        <a href="/admin/recommended-posts/add" className={`redesign-pill${pathname === '/admin/recommended-posts/add' ? ' active' : ''}`}>推荐文章</a>
                    </div>
                </ScrollArea>
            </Flex>
        </div>
    )
}